import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../app/lib/hooks';
import { getContinents } from '../app/lib/reducers/continentReducer';
import { RootState } from '../app/lib/store';
import ncNanoId from "@/utils/ncNanoId";
import { TourCategory, NavItemType } from '@/data/types'; // Adjust the path as needed
import { useTranslation } from 'react-i18next';
import { MegamenuItem } from "@/shared/Navigation/NavigationItem";
import { PathName, Route } from "@/routers/types";
import __megamenu from "./jsons/__megamenu.json";
import { t } from 'i18next';

export const useContinentNavigation = () => {
  const dispatch = useAppDispatch();
  const continents = useAppSelector((state: RootState) => state.continent.continents);
const { t } = useTranslation("guydeez");
  useEffect(() => {
    if (continents.length === 0) {
      console.log('Dispatching getContinents action');
      dispatch(getContinents(true));
    }
  }, [dispatch, continents.length]);

  return continents.map((continent) => ({
    id: ncNanoId(),
    href: `/continent/${continent.slug}`,
    name: continent.name,
    children: []
  }));
};

const megaMenuDemo: MegamenuItem[] = [
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Company",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/",
      name: i.Company,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "App Name",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/",
      name: i.AppName,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5059013/pexels-photo-5059013.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "City",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/",
      name: i.City,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5159141/pexels-photo-5159141.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Contruction",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/",
      name: i.Contruction,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/7473041/pexels-photo-7473041.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Country",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/",
      name: i.Country,
    })),
  },
];

const templatesChildrenMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing/1" as Route,
    name: "Add listing",
    type: "dropdown",
    children: [
      {
        id: ncNanoId(),
        href: "/add-listing/1" as Route,
        name: "Add listing 1",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/2" as Route,
        name: "Add listing 2",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/3" as Route,
        name: "Add listing 3",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/4" as Route,
        name: "Add listing 4",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/5" as Route,
        name: "Add listing 5",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/6" as Route,
        name: "Add listing 6",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/7" as Route,
        name: "Add listing 7",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/8" as Route,
        name: "Add listing 8",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/9" as Route,
        name: "Add listing 9",
      },
      {
        id: ncNanoId(),
        href: "/add-listing/10" as Route,
        name: "Add listing 10",
      },
    ],
  },
  //
  { id: ncNanoId(), href: "/checkout", name: "Checkout" },
  { id: ncNanoId(), href: "/pay-done", name: "Pay done" },
  //
  { id: ncNanoId(), href: "/author", name: "Author page" },
  { id: ncNanoId(), href: "/account", name: "Account page" },
  //
  {
    id: ncNanoId(),
    href: "/subscription",
    name: "Subscription",
  },
];

export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
    type: "dropdown",
    children: [
    {
      id: ncNanoId(),
      href: "/",
      name: t('navigation_homepage'),
    },
    {
      id: ncNanoId(),
      href: "/airport-pickup",
      name: t('navigation_airport_pickup_drop_off'),
    },
    {
      id: ncNanoId(),
      href: "/transfer",
      name: t('navigation_transfer'),
    },
    {
      id: ncNanoId(),
      href: "/business-trip",
      name: t('navigation_business_trip'),
      isNew: false,
    },
    {
      id: ncNanoId(),
      href: "/cruise-tour",
      name: t('navigation_cruises'),
      isNew: false,
    },
    {
      id: ncNanoId(),
      href: "/tours",
      name: t('navigation_our_tours'),
      isNew: false,
    },
  ],
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/listing-stay",
    name: "Listing Page",
    type: "dropdown",
    children: [
      {
        id: ncNanoId(),
        href: "/listing-stay",
        name: "Stay listings",
        type: "dropdown",
        children: [
          { id: ncNanoId(), href: "/listing-stay", name: "Stay page" },
          {
            id: ncNanoId(),
            href: "/listing-stay-map",
            name: "Stay page (map)",
          },
          { id: ncNanoId(), href: "/listing-stay-detail", name: "Stay Detail" },
        ],
      },

      //
      {
        id: ncNanoId(),
        href: "/listing-car",
        name: "Cars listings",
        type: "dropdown",
        children: [
          { id: ncNanoId(), href: "/listing-car", name: "Cars page" },
          { id: ncNanoId(), href: "/listing-car-map", name: "Cars page (map)" },
          { id: ncNanoId(), href: "/listing-car-detail", name: "Car Detail" },
        ],
      },

      //
      {
        id: ncNanoId(),
        href: "/listing-real-estate",
        name: "Real Estate Listings",
        type: "dropdown",
        children: [
          {
            id: ncNanoId(),
            href: "/listing-real-estate",
            name: "Real Estate Listings",
          },
          {
            id: ncNanoId(),
            href: "/listing-real-estate-map",
            name: "Real Estate Maps",
          },
        ],
      },
      //
      {
        id: ncNanoId(),
        href: "/listing-flights",
        name: "Flights listings",
      },
    ],
  },
  {
    id: ncNanoId(),
    href: "/guide",
    name: "Templates",
    type: "dropdown",
    children: templatesChildrenMenus,
  },

  {
    id: ncNanoId(),
    href: "/blog",
    name: "Other pages",
    type: "dropdown",
    children:  [
      //{ id: ncNanoId(), href: "/gift-cards", name: t('navigation_gift_card) },
      //{ id: ncNanoId(), href: "/blog", name: t('navigation_our_blog') },
      { id: ncNanoId(), href: "/faq", name: t('navigation_faq') },
      { id: ncNanoId(), href: "/about", name: t('navigation_about_us') },
      { id: ncNanoId(), href: "/contact", name: t('navigation_contact_us') },
      /* id: ncNanoId(), href: "/login", name: "Login/Signup" */
    ],
  },
];

// Function component or custom hook to build the navigation menu
export const useNavigationMenu = () => {
  const continentItems = useContinentNavigation();
  const tourCategories = useAppSelector(state => state.tourCategories.tourCategories);
  const user = useAppSelector((state: RootState) => state.auth.user);
  const { t } = useTranslation("guydeez");

  const demoChildMenus: NavItemType[] = [
    {
      id: ncNanoId(),
      href: "/",
      name: t('navigation_homepage'),
    },
    {
      id: ncNanoId(),
      href: "/airport-pickup",
      name: t('navigation_airport_pickup_drop_off'),
    },
    {
      id: ncNanoId(),
      href: "/transfer",
      name: t('transfer_title'),
    },
    {
      id: ncNanoId(),
      href: "/business-trip",
      name: t('navigation_business_trip'),
      isNew: false,
    },
    {
      id: ncNanoId(),
      href: "/cruise-tour",
      name: t('navigation_cruises'),
      isNew: false,
    },
    {
      id: ncNanoId(),
      href: "/tours",
      name: t('navigation_our_tours'),
      isNew: false,
    },
  ];

  

  const otherPageChildMenus: NavItemType[] = [
    { id: ncNanoId(), href: "/gift-cards", name: t('navigation_gift_card') },
    { id: ncNanoId(), href: "/redeem", name: t('navigation_redeem') },
    //{ id: ncNanoId(), href: "/blog", name: t('navigation_our_blog') },
    { id: ncNanoId(), href: "/faq", name: t('navigation_faq') },
    { id: ncNanoId(), href: "/about", name: t('navigation_about_us') },
    { id: ncNanoId(), href: "/contact", name: t('navigation_contact_us') },
    /* id: ncNanoId(), href: "/login", name: "Login/Signup" */
  ];


  const NAVIGATION_MENU: NavItemType[] = [
    {
      id: ncNanoId(),
      href: "/",
      name: t('navigation_homepage'),
      type: "dropdown",
      children: demoChildMenus,
      isNew: true,
    },
    {
      id: ncNanoId(),
      href: "/tours",
      name: t('navigation_our_tours'),
      children: tourCategories.map(category => ({
        id: ncNanoId(),
        href: `/tours?cat=${category.slug}`,
        name: category.entry.data[0].title,
      })),
      /*children: [
        { id: ncNanoId(), href: "/tours?cat=private-tour", name: "Private Tour" },
        { id: ncNanoId(), href: "/tours?cat=group-tour", name: "Group Tour" },
        { id: ncNanoId(), href: "/tours?cat=street-art-tour", name: "Street Art Tour" },
        { id: ncNanoId(), href: "/tours?cat=bike-tour", name: "Bike Tour" },
        { id: ncNanoId(), href: "/tours?cat=food-tour", name: "Food Tour" },
        { id: ncNanoId(), href: "/tours?cat=excursion", name: "Excursion" },
        // Additional items can be added here as needed
      ],*/
    },
    {
      id: ncNanoId(),
      href: "/zones",
      name: t('navigation_search_by_zone'),
      children: continentItems, // This is a function call, make sure it returns NavItemType[]
    },
    {
      id: ncNanoId(),
      href: "/blog",
      name: t('navigation_more'),
      type: "dropdown",
      children: otherPageChildMenus,
    },
  ];

  if (user && (user.role === 1 || user.role === 2)) {
    NAVIGATION_MENU.push({
      id: "templates-admin",
      href: "/apps/whatsapp",
      name: "Templates Admin",
    });
  }

  return NAVIGATION_MENU;
};
